import React from 'react';

import config from 'configs/app';

import { useNow } from '../hooks';
import { REVEAL_AT } from '../nirmalx';
import css from './home.module.css';

const icon = config.UI.navigation.icon.dark || config.UI.navigation.icon.default;
const REVEAL_MS = new Date(REVEAL_AT).getTime();

const RINGS = [
  { className: css.ring1, speed: '9s' },
  { className: css.ring2, speed: '14s' },
  { className: css.ring3, speed: '21s' },
];

function splitTime(ms: number) {
  const total = Math.max(0, Math.floor(ms / 1000));
  return [
    { unit: 'Days', value: Math.floor(total / 86400) },
    { unit: 'Hours', value: Math.floor(total / 3600) % 24 },
    { unit: 'Mins', value: Math.floor(total / 60) % 60 },
    { unit: 'Secs', value: total % 60 },
  ];
}

const Countdown = () => {
  const now = useNow();
  const left = REVEAL_MS - now;
  const isDone = now > 0 && left <= 0;

  return (
    <div className={ css.countdown } aria-live="off">
      <div className={ css.countLabel }>{ isDone ? 'The reveal is here' : 'The big reveal in' }</div>
      <div className={ css.countTiles }>
        { splitTime(left).map(({ unit, value }) => (
          <div key={ unit } className={ css.countTile }>
            { /* Re-keyed on every change, so each new value replays the tick animation. */ }
            <span key={ now > 0 ? value : 'pending' } className={ css.countValue }>
              { now > 0 ? String(value).padStart(2, '0') : '--' }
            </span>
            <span className={ css.countUnit }>{ unit }</span>
          </div>
        )) }
      </div>
      <div className={ css.signal }>
        <span className={ css.bars } aria-hidden="true"><span/><span/><span/><span/><span/></span>
        Signal from the horizon
      </div>
    </div>
  );
};

/** "Something bigger is rising": the mainnet teaser with a countdown. Future tense — nothing here is launched yet. */
const HypeBanner = () => (
  <div className={ css.hypeWrap }>
    <section className={ css.hype } aria-labelledby="nx-hype-title">
      <div className={ css.hypeInner }>
        <div>
          <span className={ css.hypeBadge }><span className={ css.dot }/>In the pipeline</span>
          <h2 id="nx-hype-title" className={ css.hypeTitle }>Something bigger<br/>is rising.</h2>
          <p className={ css.hypeText }>
            <b>NirmalX Mainnet</b> is on its way. This testnet is its proving ground: every block sealed here brings
            it one step closer.
          </p>
          <div className={ css.ctaRow }>
            <a href="#horizon" className={ css.ctaPrimary }>See what&apos;s coming →</a>
            <a href="#stream" className={ css.ctaGhost }>Watch blocks live</a>
          </div>
        </div>
        <div className={ css.hypeSide }>
          <div className={ css.orbit } aria-hidden="true">
            { RINGS.map((ring) => (
              <div key={ ring.speed } className={ `${ css.ring } ${ ring.className }` }>
                <div className={ css.ringSpin } style={{ '--speed': ring.speed } as React.CSSProperties}/>
              </div>
            )) }
            { icon && <img src={ icon } alt="" className={ css.coin }/> }
          </div>
          <Countdown/>
        </div>
      </div>
    </section>
  </div>
);

export default React.memo(HypeBanner);
